import { Redirect } from "react-router-dom";

import { FeatureFlags, useFeatureEnabled } from "~/v2/helpers/featureFlags";
import { Path } from "~/v2/path";
import { WhitelistAddressPresentation } from "../../coinTransfers/whitelistAddress/WhitelistAddress.pres";
import { useDigitalAssetWhitelistAddressController } from "./WhitelistAddress.controller";

const WhitelistAddressInner = () => {
  const props = useDigitalAssetWhitelistAddressController();
  return <WhitelistAddressPresentation {...props} />;
};

export const WhitelistAddressConnector = () => {
  const isTRCEnabled = useFeatureEnabled(FeatureFlags.CRYPTO_TRC);

  if (!isTRCEnabled) {
    return <Redirect to={Path.ROUTE_DIGITAL_ASSETS_TRANSFERS} />;
  }

  return <WhitelistAddressInner />;
};
